<div class="coupons-dialog">
    <div class="coupons-dialog__content">
        <button class="coupons-dialog__close" type="button" mat-dialog-close aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
        <span class="coupons-dialog__eyebrow">
            NINA RECOMPENSAS
        </span>
        <h2>
            CANTIDAD DE BOLETOS
        </h2>
        <div class="coupons-dialog__points">
            <strong>
                {{ data.boletos }}
            </strong>
            <span>
                boletos
            </span>
        </div>
        <p class="coupons-dialog__description">
            Tienes acumulados
            <strong>{{ data.boletos }} boletos</strong>
            para la promoción
            <span class="nina-brand-italic">
                {{ data.titulo }}
            </span>.
            Consulta tu historial de pedidos para verificar
            los boletos acreditados por cada compra.
        </p>
    </div>
    <button class="coupons-dialog__button" type="button" mat-dialog-close>
        Aceptar
    </button>
</div>